import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Lock, CheckCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      toast.success("Password updated");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reset link is invalid or expired");
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#08080a", padding: "1.5rem" }}>
      <div className="card" style={{ padding: "2.8rem", width: "100%", maxWidth: 420 }} data-testid="reset-password-card">
        <div className="font-serif" style={{ fontSize: "1.6rem", textAlign: "center", marginBottom: "0.4rem" }}>
          <span style={{ color: "var(--text)" }}>DSCR</span><span style={{ color: "var(--gold)" }}>Daily</span>
        </div>

        {!token ? (
          <p className="body-text" style={{ textAlign: "center", marginTop: "1.4rem" }} data-testid="reset-no-token">
            This reset link is missing its token. Please use the link from your email or request a new one.
          </p>
        ) : done ? (
          <div style={{ textAlign: "center", marginTop: "1.4rem" }} data-testid="reset-success">
            <CheckCircle size={40} color="var(--green)" style={{ margin: "0 auto 1rem" }} />
            <p className="body-text" style={{ marginBottom: "1.6rem" }}>Your password has been updated. You can now sign in with your new password.</p>
            <button className="btn-gold" style={{ width: "100%" }} data-testid="go-signin-btn" onClick={() => navigate("/")}>Back to Sign In</button>
          </div>
        ) : (
          <>
            <p className="body-text" style={{ textAlign: "center", fontSize: "0.88rem", margin: "0.8rem 0 1.6rem" }}>
              <Lock size={13} style={{ verticalAlign: "middle" }} /> Choose a new password for your account.
            </p>
            <div style={{ display: "grid", gap: "0.9rem" }}>
              <input className="field" type="password" data-testid="new-password-input" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} />
              <input className="field" type="password" data-testid="confirm-password-input" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
              <button className="btn-gold" style={{ width: "100%" }} data-testid="reset-submit-btn" disabled={busy} onClick={submit}>{busy ? "Updating…" : "Update Password"}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
